import axios from "axios";
import { baseUrl } from "../Base_url";
export const getAllSchoolDistricts = async (token, page, limit) => {
  try {
    const res = await axios.get(`${baseUrl}/admin/school-district/all`, {
      headers: { Authorization: `Bearer ${token}` },
      // { Authorization: `Bearer jhjhjhkjjklk` }
    });
    return { error: false, res: res };
  } catch (e) {
    const err = {
      error: true,
      data: e?.response?.data?.data,
      // data:e
    };
    return err;
  }
};
export const getSchoolByDistrict = async (id, token) => {
  try {
    const res = await axios.get(
      `${baseUrl}/admin/school-district/${id}/school/all`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return { error: false, res: res };
  } catch (e) {
    const err = { error: true, data: e?.response?.data?.data };
    return err;
  }
};
export const getAllSchoolTeachers = async (sid, token) => {
  try {
    const res = await axios.post(
      `${baseUrl}/getTeacherBySchoolId`,
      { id: sid },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return { error: false, res: res };
  } catch (e) {
    const err = { error: true, data: e?.response?.data?.data };
    return err;
  }
};
export const createNewLaunchTrek = async (data, token) => {
  try {
    const res = await axios.post(`${baseUrl}/admin/launchtrek/createLaunchTrek`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { error: false, res: res };
  } catch (e) {
   //console.log"launch e", e);
    const err = { error: true, data: e?.response?.data?.data };
    return err;
  }
};

export const getLaunchTrekData = async (token,page,limit,orderBy,order) => {
  try {
    const res = await axios.get(`${baseUrl}/admin/launchtrek/getLauchtrekFiles`, {
      params: { page: page, limit:limit,orderBy:orderBy,order:order },
      headers: { Authorization: `Bearer ${token}` },
    });
    return { error: false, res: res };
  } catch (e) {
   //console.log"graph  e", e);
    return e;
  }
};
export const getFileDetails = async (id, token) => {
  try {
    console.log("id.........",id)
    const res = await axios.get(`${baseUrl}/admin/launchtrek/getLauchtrekFilesById`, {
      params: { id: id },
      headers: { Authorization: `Bearer ${token}` },
    });
    return { error: false, res: res };
  } catch (e) {
   //console.log"getfile  e", e);
    return e;
  }
};
export const getGraphDetails = async (id, token) => {
  try {
    const res = await axios.get(`${baseUrl}/admin/launchtrek/getGraphByfileId`, {
      params: { id: id },
      headers: { Authorization: `Bearer ${token}` },
    });
    return { error: false, res: res };
  } catch (e) {
   //console.log"getfile  e", e);
    return e;
  }
};
export const updateLaunchtrekFile = async (id, data, token) => {
  try {
    const res = await axios.patch(`${baseUrl}/admin/launchtrek/editFileData`, data, {
      params: { id: id },
      headers: { Authorization: `Bearer ${token}` },
    });
  
    return { error: false, res: res };
  } catch (e) {
    const err = { error: true, data: e?.response?.data?.data };
    return err;
  }
};

export const deleteLaunchTrekFile = async (id, token) => {
  try {
    const res = await axios.delete(`${baseUrl}/admin/launchtrek/deleteLaunchFiles?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { error: false, res: res };
  } catch (e) {
    const err = { error: true, data: e?.response?.data?.data };
    return err;
  }
};
 